import React from 'react'

// Hooks
import { createContext, useContext } from "react";
// cart context
import { DataContext } from "./CartProvider";

// @ts-ignore
export const SpentContext = createContext();


export default function SpentProvider({ children }) {
    const context = useContext(DataContext);

    const { items } = context;

    let count = 0;
    const totalSpent = items.reduce((acc, nxt) => {
        count++;
        return acc + parseInt(nxt.price);
    }, 0)
    return (
        <SpentContext.Provider value={{ count, totalSpent }}>
            {children}
        </SpentContext.Provider>
    )
}
